const layerDescriptionLoadedReducer = (state = null, action) => {
  switch(action.type) {
    case 'LAYER_DESCRIPTION_LOADED':
      return action.payload;
    default:
      return state
    }
  }

  export default layerDescriptionLoadedReducer;